export const addTimeSeparatorToDate = (date: string) => (date ? date.replace(" ", "T") : "");
